import type { ReactNode } from 'react';
import type React from 'react';

import type { Breadcrumb } from '@xing-com/crate-people-directory-breadcrumbs';
import { Breadcrumbs } from '@xing-com/crate-people-directory-breadcrumbs';
import { LetterNavigation } from '@xing-com/crate-people-directory-letter-navigation';
import { MetaData } from '@xing-com/crate-people-directory-meta-data';
import { PageHeader } from '@xing-com/crate-people-directory-page-header';
import { usePeopleDirectoryPageView } from '@xing-com/crate-people-directory-tracking';
import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';
import { Container } from '@xing-com/layout-primitives';

import { StyledSection } from './page-layout.styles';

type PageLayoutProps = {
  letter?: string;
  seoUrl?: string;
  pageName: string;
  children: ReactNode;
  seoTitle?: string;
  seoDescription?: string;
  index?: boolean;
  breadcrumbs?: Breadcrumb[];
  hidePageHeader?: boolean;
  hideLetterNavigation?: boolean;
  pageHeaderAsSecondaryHeadline?: boolean;
};

export const PageLayout: React.FC<PageLayoutProps> = ({
  letter,
  seoTitle,
  seoDescription,
  pageName,
  seoUrl,
  index,
  children,
  breadcrumbs,
  hidePageHeader,
  hideLetterNavigation,
  pageHeaderAsSecondaryHeadline,
}) => {
  usePeopleDirectoryPageView(pageName);

  return (
    <StyledSection noBlockPadding>
      <Container>
        <MetaData
          title={seoTitle}
          description={seoDescription}
          url={seoUrl ? sanitizeUrl(seoUrl) : undefined}
          index={index}
        />

        <Breadcrumbs items={breadcrumbs} />

        {hidePageHeader ? null : (
          <>
            <PageHeader asSecondaryHeadline={pageHeaderAsSecondaryHeadline} />

            {hideLetterNavigation ? null : (
              <LetterNavigation activeLetter={letter} />
            )}
          </>
        )}
        {children}
      </Container>
    </StyledSection>
  );
};
